import React, { useEffect } from 'react';
import './locales/i18n';
import { createTheme, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TimeAgo from 'javascript-time-ago';
import es from 'javascript-time-ago/locale/es';
import en from 'javascript-time-ago/locale/en'; // agrega más si necesitas
import { useTranslation } from 'react-i18next';
import RouterComponent from './router';
import theme from './theme';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/en'; // importa todos los que necesites

function App() {
    const customTheme = createTheme(theme);
    const { i18n, t } = useTranslation();

    // Agregar idiomas disponibles para TimeAgo
    TimeAgo.addDefaultLocale(en);
    TimeAgo.addLocale(es);

    // Aplicar locale de dayjs según idioma activo
    useEffect(() => {
        const supportedLocales = ['en', 'es'];
        const selectedLocale = supportedLocales.includes(i18n.language)
            ? i18n.language
            : 'en';
        dayjs.locale(selectedLocale);
    }, [i18n.language]);

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={i18n.language} // <-- este es el punto clave
        >
            <ThemeProvider theme={customTheme}>
                <RouterComponent />
            </ThemeProvider>
        </LocalizationProvider>
    );
}

export default App;
